module.exports = __webpack_public_path__ + "static/media/1-4.89091668.svg";